import React from "react";

// Growth-plan tiers by slug (mirrors PLAN_RANK in Pricing.js).
export const PLAN_RANK = { free: 0, starter: 1, growth: 2, scale: 3 };
export const hasGrowth = (business) =>
  (PLAN_RANK[business?.current_subscription?.planId] ?? 0) >= PLAN_RANK.growth;

// Soft-gate banner: shown at the top of a Growth-only feature page on lower
// plans. The page stays visible (a preview); this nudges the upgrade.
const UpgradeBanner = ({ feature = "This feature" }) => (
  <div className="mb-4 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-theme-accentSoft bg-theme-accentSoft px-4 py-3">
    <p className="text-sm text-theme-secondaryText">
      <span className="font-semibold">{feature}</span> is a Growth-plan feature —
      upgrade to turn it on for your community.
    </p>
    <button
      type="button"
      onClick={() => {
        window.location.hash = "billing";
      }}
      className="flex-shrink-0 rounded-lg bg-theme-accent px-3.5 py-1.5 text-xs font-semibold text-theme-accentText"
    >
      Upgrade
    </button>
  </div>
);

export default UpgradeBanner;
